import React from 'react';
import './style.scss';
import { AnimatedHeading } from '../../shared/TextFx';
import aramexLogo from './images/aramax-white.png';
import ocsLogo from './images/ocs-white.png';
import fedexLogo from './images/fedex-white.png';
import dhlLogo from './images/dhl-white.png';
import upsLogo from './images/ups-white.png';

const CLIENTS = [
  { number: '01', alt: 'Aramex', src: aramexLogo },
  { number: '02', alt: 'OCS', src: ocsLogo },
  { number: '03', alt: 'FedEx', src: fedexLogo },
  { number: '04', alt: 'DHL', src: dhlLogo },
  { number: '05', alt: 'UPS', src: upsLogo },
];

const ClientsSec = () => (
  <section className="clients">
    <div className="container">
      <AnimatedHeading className="clients__title" text="Partners Clients" />
      <div className="clients__container">
        {CLIENTS.map((client) => (
          <div className="clients__item" key={client.number}>
            <span className="clients__item-number">{client.number}</span>
            <img alt={client.alt} className="clients__item-logo" src={client.src} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ClientsSec;
